module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Index","download_manual":"Download complete PDF manual","new_article":"New Article","faq":"Frequently Asked Questions"},"pt-BR":{"title":"Índice","download_manual":"Baixar manual completo em PDF","new_article":"Novo Artigo","faq":"Dúvidas Frequentes"}}')
  delete Component.options._Ctor
}
